import React from 'react';
import { useTranslation } from 'react-i18next';
import { CaseData, PendingEvent, VerdictOutcome, VerdictType } from '../core/types';

interface Props {
  verdict: VerdictType;
  outcome: VerdictOutcome;
  caseData: CaseData;
  // Delayed events that just fired (from previous verdicts), shown as consequences
  firedEvents: PendingEvent[];
  onNext: () => void;
}

function DeltaBadge({ value }: { value: number }) {
  if (value === 0) return null;
  const sign = value > 0 ? '+' : '';
  const cls = value > 0 ? 'delta positive' : 'delta negative';
  return <span className={cls}>{sign}{value}</span>;
}

const ResultModal: React.FC<Props> = ({ verdict, outcome, caseData, firedEvents, onNext }) => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language.startsWith('zh');
  const feedback = isZh ? outcome.feedbackZh : outcome.feedbackEn;

  return (
    <div className="result-overlay">
      <div className="result-modal">
        <div className="result-verdict-label">{t(`decision.${verdict}`)}</div>

        <p className="result-feedback">{feedback}</p>

        <div className="result-state-changes">
          <div className="state-change-row">
            <span>KPI</span>
            <DeltaBadge value={outcome.kpiDelta} />
          </div>
          <div className="state-change-row">
            <span>{t('topbar.careerRisk')}</span>
            <DeltaBadge value={outcome.careerRiskDelta} />
          </div>
          <div className="state-change-row">
            <span>{t('topbar.proceduralRisk')}</span>
            <DeltaBadge value={outcome.proceduralRiskDelta} />
          </div>
        </div>

        {firedEvents.length > 0 && (
          <div className="fired-events">
            <p className="fired-events-title">{t('result.followUp')}</p>
            {firedEvents.map(e => (
              <div key={e.id} className="fired-event">
                <p>{isZh ? e.descriptionZh : e.descriptionEn}</p>
                <div className="state-change-row">
                  <DeltaBadge value={e.kpiDelta} />
                  <DeltaBadge value={e.careerRiskDelta} />
                  <DeltaBadge value={e.proceduralRiskDelta} />
                </div>
              </div>
            ))}
          </div>
        )}

        <button className="next-btn" onClick={onNext}>
          {t('result.next')}
        </button>
      </div>
    </div>
  );
};

export default ResultModal;
